<!-- loading spinner -->
<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">
  <div class="field grid">
    <label class="col-fixed" for="selectedTiles">Tiles</label>
    <div class="col-fixed dropdown-field">
      <p-multiSelect formControlName="selectedTiles" [options]="selectableTiles" defaultLabel="Choose"
                     selectedItemsLabel="{0} items selected">
      </p-multiSelect>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="displayNonCurrentManagers">Display Non-Current Managers on overview and lister page
      (default):</label>
    <div class="col-fixed">
      <p-inputSwitch formControlName="displayNonCurrentManagers"></p-inputSwitch>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="skipListerPage">Skip lister page (go straight to dashboard) when only one record found
      (default):</label>
    <div class="col-fixed">
      <p-inputSwitch formControlName="skipListerPage"></p-inputSwitch>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="displayObsoleteUnits">Display Obsolete units on overview, lister page
      (default):</label>
    <div class="col-fixed">
      <p-inputSwitch formControlName="displayObsoleteUnits"></p-inputSwitch>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="filterField">Exclude Creditor/Supplier from Overview and Lister page:</label>
    <div class="col-fixed horizontal">
      <p-dropdown
        formControlName="filterField"
        [options]="selectableFields"
        (onChange)="selectedFieldChanged($event.value)"
        appendTo="body"
        placeholder="Choose field type to exclude by"></p-dropdown>
      <p-multiSelect
        formControlName="selectedFilterItems"
        [options]="filterItems | async"
        appendTo="body"
        placeholder="Choose field values to exclude"
        *ngIf="(selectedFieldObservable | async)"></p-multiSelect>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="displayNonCurrentLeasesAndTenants">Display non-current leases and tenants on overview,
      lister page (default):</label>
    <div class="col-fixed">
      <p-inputSwitch formControlName="displayNonCurrentLeasesAndTenants"></p-inputSwitch>
    </div>
  </div>
  <div class="field grid">
    <label class="col-fixed" for="displayNonCurrentHeadLeasesAndLandlords">Display non-current head leases and landlords
      on overview,
      lister page (default):</label>
    <div class="col-fixed">
      <p-inputSwitch formControlName="displayNonCurrentHeadLeasesAndLandlords"></p-inputSwitch>
    </div>
  </div>
</form>
